// src/scene/config/Physics/AppleConfig.ts
// Apple physics configuration — generated by IslandDebug.
// Paste this entire file to replace src/scene/config/Physics/AppleConfig.ts

// ── World ─────────────────────────────────────────────────────────────────────
export const GRAVITY           = -9.82;
export const SUBSTEPS          = 10;
export const SAFETY_PLANE_Y   = -2.0;

// ── Apple body (compound: 4 corner spheres) ─────────────────────────────────
export const APPLE_BODY_Y_OFFSET = -0.02;  // offset whole compound center from visual center
export const APPLE_MASS        = 0.15;    // kg
export const LINEAR_DAMPING    = 0.10;
export const ANGULAR_DAMPING   = 0.50;

// All 4 spheres share a radius and spread — adjust these two to resize the cage
export const SPHERE_RADIUS     = 0.039;   // individual sphere radius
export const SPHERE_SPREAD     = 0.025;   // distance from center to each corner
export const SPHERE_Y_TOP      = 0.025;   // Y offset for top pair
export const SPHERE_Y_BOTTOM   = -0.025;  // Y offset for bottom pair

// ── Contact material ──────────────────────────────────────────────────────────
export const FRICTION          = 0.40;
export const RESTITUTION       = 0.15;

// ── Sleep detection ───────────────────────────────────────────────────────────
export const SLEEP_SPEED_LIMIT = 0.05;
export const SLEEP_TIME_LIMIT  = 0.80;

// ── Collider geometry ─────────────────────────────────────────────────────────
export const TREE_TRUNK_MAX_Y  = 1.00;    // world-space Y cutoff — only trunk geometry below this gets a collider
